<h2 [class.label-delete]="expired" [class.foreground-disabled-text]="!expired" class="d-block mat-caption mb-0">
    {{ expired ? 'Expired:' : 'Expires:' }} {{ expirationMonth }} / {{ expirationYear }}
</h2>
